<div class="manager-dashboard">
  <div class="dashboard-card">
    <!-- Header Section -->
    <div class="header-section">
      <div class="logo-container">
        <img src="assets/img/logo-projecao-profissional.svg" alt="Logo Projeção Profissional" class="dashboard-logo" />
      </div>
      <h1 class="dashboard-title">Dashboard Gerencial</h1>
      <p class="dashboard-subtitle">Visão geral do desempenho da sua equipe</p>
    </div>

    <!-- Quick Actions -->
    <section class="quick-actions">
      <h2 class="section-title">Ações Rápidas</h2>
      <div class="actions-grid">
        <button mat-raised-button class="action-button" routerLink="/funcionarios">
          <mat-icon>people</mat-icon>
          <span>Funcionários</span>
        </button>
        <button mat-raised-button class="action-button" routerLink="/profissionais-autonomos">
          <mat-icon>person</mat-icon>
          <span>Profissionais</span>
        </button>
        <button mat-raised-button class="action-button" routerLink="/prestadores-de-servico">
          <mat-icon>business</mat-icon>
          <span>Prestadores</span>
        </button>
      </div>
    </section>

    <!-- KPIs Section -->
    <section class="kpis-section">
      <h2 class="section-title">Indicadores Principais</h2>
      <div class="kpis-grid">
        <div class="kpi-card" *ngFor="let kpi of kpis">
          <div class="kpi-icon">
            <mat-icon color="primary">{{ kpi.icon }}</mat-icon>
          </div>
          <div class="kpi-content">
            <h3 class="kpi-value">{{ kpi.value }}</h3>
            <p class="kpi-label">{{ kpi.label }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Performance Analysis Section -->
    <!-- <section class="performance-section">
      <h2 class="section-title">Análise de Performance</h2>

      <mat-card class="performance-card">
        <mat-card-header>
          <div class="card-header-content">
            <mat-card-title>
              <mat-icon>trending_up</mat-icon>
              Avaliações Realizadas
            </mat-card-title>
            <div class="period-selector">
              <button
                mat-button
                [class.active]="selectedPeriod === 'week'"
                (click)="selectPeriod('week')"
                class="period-button"
              >
                7 dias
              </button>
              <button
                mat-button
                [class.active]="selectedPeriod === 'month'"
                (click)="selectPeriod('month')"
                class="period-button"
              >
                30 dias
              </button>
              <button
                mat-button
                [class.active]="selectedPeriod === 'quarter'"
                (click)="selectPeriod('quarter')"
                class="period-button"
              >
                90 dias
              </button>
            </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <div class="chart-container">
            <canvas baseChart [type]="'line'" [data]="evaluationsChartData" [options]="evaluationsChartOptions">
            </canvas>
          </div>
          <div class="chart-summary">
            <div class="summary-item">
              <span class="summary-label">Total de Avaliações:</span>
              <span class="summary-value">{{ getTotalEvaluations() }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Média Diária:</span>
              <span class="summary-value">{{ getAverageEvaluations() }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="performance-card">
        <mat-card-header>
          <div class="card-header-content">
            <mat-card-title>
              <mat-icon>bar_chart</mat-icon>
              Metas vs Tarefas
            </mat-card-title>
            <div class="chart-legend">
              <div class="legend-item">
                <div class="legend-color goals-color"></div>
                <span>Metas</span>
              </div>
              <div class="legend-item">
                <div class="legend-color tasks-color"></div>
                <span>Tarefas</span>
              </div>
            </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <div class="chart-container">
            <canvas baseChart [type]="'bar'" [data]="goalsTasksChartData" [options]="goalsTasksChartOptions"> </canvas>
          </div>
          <div class="chart-summary">
            <div class="summary-item">
              <span class="summary-label">Total de Metas:</span>
              <span class="summary-value">{{ getTotalGoals() }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Total de Tarefas:</span>
              <span class="summary-value">{{ getTotalTasks() }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Taxa de Conclusão:</span>
              <span class="summary-value">{{ getCompletionRate() }}%</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </section> -->

    <!-- Team Overview -->
    <!-- <section class="team-overview">
      <h2 class="section-title">Visão Geral da Equipe</h2>

      <mat-card class="team-card" *ngIf="colaboradores.length > 0">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>people</mat-icon>
            Funcionários ({{ colaboradores.length }})
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="team-stats">
            <div class="stat-item">
              <span class="stat-value">{{ getTotalMetas(colaboradores) }}</span>
              <span class="stat-label">Metas Ativas</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">{{ getTotalTarefas(colaboradores) }}</span>
              <span class="stat-label">Tarefas Pendentes</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">{{ getAverageDocs(colaboradores) }}%</span>
              <span class="stat-label">Docs Lidos (Média)</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="team-card" *ngIf="autonomos.length > 0">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>person</mat-icon>
            Profissionais Autônomos ({{ autonomos.length }})
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="team-stats">
            <div class="stat-item">
              <span class="stat-value">{{ getTotalMetas(autonomos) }}</span>
              <span class="stat-label">Metas Ativas</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">{{ getTotalTarefas(autonomos) }}</span>
              <span class="stat-label">Tarefas Pendentes</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">{{ getAverageDocs(autonomos) }}%</span>
              <span class="stat-label">Docs Lidos (Média)</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="team-card" *ngIf="prestadores.length > 0">
        <mat-card-header>
          <mat-card-title>
            <mat-icon>business</mat-icon>
            Prestadores de Serviço ({{ prestadores.length }})
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="team-stats">
            <div class="stat-item">
              <span class="stat-value">{{ getTotalMetas(prestadores) }}</span>
              <span class="stat-label">Metas Ativas</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">{{ getTotalTarefas(prestadores) }}</span>
              <span class="stat-label">Tarefas Pendentes</span>
            </div>
            <div class="stat-item">
              <span class="stat-value">{{ getAverageDocs(prestadores) }}%</span>
              <span class="stat-label">Docs Lidos (Média)</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <div *ngIf="colaboradores.length === 0 && autonomos.length === 0 && prestadores.length === 0" class="empty-state">
        <mat-icon class="empty-icon">group</mat-icon>
        <h3>Nenhuma equipe cadastrada</h3>
        <p>Comece adicionando funcionários, profissionais autônomos ou prestadores de serviço.</p>
        <button mat-raised-button color="primary" routerLink="/funcionarios">
          <mat-icon>add</mat-icon>
          Adicionar Funcionário
        </button>
      </div>
    </section> -->

    <!-- Recent Activity -->
    <!-- <section class="recent-activity" *ngIf="recentActivities.length > 0">
      <h2 class="section-title">Atividades Recentes</h2>
      <mat-card class="activity-card">
        <mat-card-content>
          <div class="activity-list">
            <div class="activity-item" *ngFor="let activity of recentActivities">
              <div class="activity-icon">
                <mat-icon>{{ activity.icon }}</mat-icon>
              </div>
              <div class="activity-content">
                <p class="activity-text">{{ activity.text }}</p>
                <span class="activity-time">{{ activity.time }}</span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </section> -->
  </div>
</div>
